
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill":"#E6ECF4"}}),_c('path',{attrs:{"fill":"#F11C33","d":"M11 9h2v8h-2z"}}),_c('path',{attrs:{"d":"M18.968 17.993L12.388 5.77a.25.25 0 00-.348-.096.25.25 0 00-.092.096L5.366 17.993a.25.25 0 00.22.368H18.75a.251.251 0 00.213-.122.25.25 0 00.005-.246zm-6.175-1.134h-1.25v-1.25h1.25v1.25zm-.125-1.998h-1l-.188-5h1.375l-.187 5z","fill":"#222F5A"}})])
          )
        }
      }
    